export default __webpack_public_path__ + "static/media/place_holder_table2.39f29efa.svg";